// extracted by mini-css-extract-plugin
export default {"paymentDans":"style_paymentDans__jzDd4"};